<template>
  <div class="home">
  
    <video id="#camera" ref="video"></video>
    <div class="scan-region-highlight" style="position: absolute; left:10px; pointer-events: none; transform: scaleX(-1); width: calc(100% - 20px); height: calc(100% - 50%); top: 20%; z-index:999;">
      <svg class="scan-region-highlight-svg" viewBox="0 0 238 238" preserveAspectRatio="true" style="position:absolute;width:100%;height:80%;left:0;top:0;fill:none;stroke:#F26522;stroke-width:4;stroke-linecap:round;stroke-linejoin:round"><path d="M31 2H10a8 8 0 0 0-8 8v21M207 2h21a8 8 0 0 1 8 8v21m0 176v21a8 8 0 0 1-8 8h-21m-176 0H10a8 8 0 0 1-8-8v-21"></path></svg>
      <svg class="code-outline-highlight" preserveAspectRatio="true" style="display:none;width:100%;height:100%;fill:none;stroke:#F26522;stroke-width:5;stroke-dasharray:25;stroke-linecap:round;stroke-linejoin:round"><polygon></polygon></svg>
      </div>
    <va-button
      icon="arrow_back"
      icon-color="#ffffff50"
      color="danger"
      class="mr-3 mb-2 boton-regresar"
      @click="goBack(null);"
  >
      Cancelar
    </va-button>
  </div>
</template>

<script>
import QrScanner from 'qr-scanner';
import { VaButton } from 'vuestic-ui/web-components';

export default {
  name: 'ScanView',
  params: {
    code : String
  },
  data:function(){
    return {
      qrScanner: null
    }
  },
  components: {
    VaButton
  },
   mounted(){

    this.qrScanner = new QrScanner(
      this.$refs.video,
       result => {  this.goBack({code:result.data}) },
      { returnDetailedScanResult: true });
      this.qrScanner.start();

  },
  methods:{
    goBack(params){
      this.qrScanner.stop();
      this.$router.replace({ name: 'home', params:params });
    }
  }
}
</script>

<style scoped>

.boton-regresar{
  position:absolute;
  top: calc(100% - 200px);
  left: calc(50% - 55px);
  background-color: --app-color-primary;
}
video{
  width: 100% !important;
}
</style>
